import axios from "axios";
import { Cookies } from "react-cookie";
import { proxy } from "../config";
const cookie = new Cookies();

export const login = async (email, password) => {
    const token = await cookie.get("token");
    return await axios.post(`${proxy}/admin/login`, {
        email: email,
        password: password
    }, {
        headers: { Authorization: token }
    });
};

export const getAdmins = async () => {
    const token = await cookie.get("token");
    return await axios.get(`${proxy}/admin/all`, {
        headers: { Authorization: token }
    });
};

export const removeFromListOfUsers = async (id, ids) => {
    const token = await cookie.get("token");
    return await axios.put(`${proxy}/admin/remove_from_list/${id}`, {
        ids: ids
    }, {
        headers: { Authorization: token }
    });
};

export const addToListOfUsers = async (id, ids) => {
    const token = await cookie.get("token");
    return await axios.put(`${proxy}/admin/add_to_list/${id}`, {
        ids: ids
    }, {
        headers: { Authorization: token }
    });
};

export const getTeamOfAdmin = async (id, page, search) => {
    const token = await cookie.get("token");
    return await axios.post(`${proxy}/admin/get_users/${id}/${page}`, {
        search: search
    }, {
        headers: { Authorization: token }
    });
};

export const getNonAdmin = async (page, search) => {
    const token = await cookie.get("token");
    return await axios.post(`${proxy}/admin/get_non_distributed_users/${page}`, {
        search: search
    }, {
        headers: { Authorization: token }
    });
};

export const changeAdmin = async (oldAdmin, newAdmin, userId) => {
    const token = await cookie.get("token");
    return await axios.put(`${proxy}/admin/remove_and_add_user`, {
        old_admin: oldAdmin,
        new_admin: newAdmin,
        user_id: userId,
    }, {
        headers: { Authorization: token }
    });
};

export const changePassword = async (old_password, password) => {
    const token = await cookie.get("token");
    return await axios.put(`${proxy}/admin/change_password`, {
        old_password: old_password,
        password: password
    }, {
        headers: { Authorization: token }
    });
};

export const changeBulkAdmin = async (ids, old_admin, new_admin) => {
    const token = await cookie.get("token");
    return await axios.put(`${proxy}/admin/change_admin`, {
        ids: ids,
        new_admin: new_admin,
        old_admin: old_admin,
    }, {
        headers: { Authorization: token }
    });
};

export const createAdmin = async (name, email, password) => {
    const token = await cookie.get("token");
    return await axios.post(`${proxy}/admin/create`, {
        name: name,
        email: email,
        password: password
    }, {
        headers: { Authorization: token }
    });
};

export const deleteAdmin = async (id) => {
    const token = await cookie.get("token");
    return await axios.delete(`${proxy}/admin/delete_admin/${id}`, {
        headers: { Authorization: token }
    });
};

export const changePasswordBySuper = async (id, password) => {
    const token = await cookie.get("token");
    return await axios.put(`${proxy}/admin/change_password_by_super/${id}`, {
        password: password
    }, {
        headers: { Authorization: token }
    });
};

export const getAlert = async (id, password) => {
    const token = await cookie.get("token");
    return await axios.get(`${proxy}/admin/get_alert`, {
        headers: { Authorization: token }
    });
};